import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';

import DowngradeTimer from './DowngradeTimer';

import {
  downgradeTitle,
  downgradeText,
} from './main.text';

import CustomModal from '../common/modals/CustomModal';

const textStyle = {
  fontFamily: 'roboto-regular',
  fontSize: 14,
  width: 500,
};

export default function NonAdminDowngradeModal({
  visible,
  users = [],
  userLimit = 4,
  subscriptionEnd,
  onCloseClicked
}) {
  const [requiredArchiveAmount, setRequiredArchiveAmount] = useState(0);

  useEffect(() => {
    const activeCount = users.length;
    setRequiredArchiveAmount(Math.max(activeCount - userLimit,0));
  }, [users, userLimit]);

  return (
    <CustomModal
      title={downgradeTitle}
      visible={visible}
      width={600}
      onCloseClicked={onCloseClicked}
    >
      <div style={{ width:'100%' }}>
        <Row style={{ width:'100%', marginBottom: 0 }} justify='center'>
          <Col>
            <p style={textStyle}>{downgradeText}</p>
            <p style={textStyle}>
              This can happen if your account owner has reduced your subscription license count, cancelled your subscription, or your payment has failed.<br/>
            </p>
            <div style={textStyle}>
              Please instruct your account owner to either upgrade your account's subscription
              <br/>
              <div>
                OR archive <b style={{
                  fontSize: 20,
                  color: requiredArchiveAmount > 0 ? 'red' : 'inherit'
                }}>{requiredArchiveAmount}</b> more users
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ width: '100%' }} justify='center'>
          <DowngradeTimer subscriptionEnd={subscriptionEnd}/>
        </Row>
        <Row style={{ width:'100%', marginTop: 20 }} justify='center'>
          <p style={textStyle}>
            Please resolve this issue before the grace period expires.
          </p>
          <p style={textStyle}>
            Failure to resolve the issue before the end of the grace period
            will result in automatic archival of the required number of user accounts.
          </p>
        </Row>
      </div>
    </CustomModal>
  );
}
